
import React from 'react'
import { JSX } from 'react'
import { AllBanksTypes, bankOptions } from 'syncra-storybook/shared/utils'

export const getBankMeta = (
  bankName: string,
  className = ''
): { title: string; icon: JSX.Element | null } => {

  const matchedKey = (Object.keys(AllBanksTypes) as Array<keyof typeof AllBanksTypes>).find(
    (key) =>
    {
      return key === bankName
    }
  )

  if (!matchedKey) {
    return { title: bankName, icon: null }
  }

  const key = AllBanksTypes[matchedKey] as AllBanksTypes
  const option = bankOptions[key]

  const iconWithClass = option?.icon ? React.cloneElement(option.icon, { className }) : null

  return { title: option?.title ?? bankName, icon: iconWithClass }
}
